export default __webpack_public_path__ + "static/media/cashsweep_IconWB.68c1a230.jpg";